import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EditableInaSchoolEnrollment } from '../model/ina-school-enrollment';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { HelperService } from 'src/app/service/helper.service';
import { Region } from 'src/app/model/region.model';
import { AccessService } from 'src/app/component/navigation/service/access.service';
import { InaSchoolEnrollmentsService } from '../../../service/ina-school-enrollments.service';
import { Router } from "@angular/router";
import { Msg } from 'src/app/component/auth/model/user.model';


@Component({
    selector: 'app-ina-table',
    templateUrl: './ina-table.component.html',
    styleUrls: ['./ina-table.component.scss']
})
export class InaTableComponent implements OnInit {
    @Input() studentId: number;
    @Input('inaSchoolEnrollments') lstEditableINASE: EditableInaSchoolEnrollment[];

    @Input() editing: boolean;
    @Output() modificationEvent = new EventEmitter<EditableInaSchoolEnrollment>();

    @ViewChild(MatPaginator) paginator: MatPaginator;

    displayedColumns: string[] = InaSchoolColumns.map((col) => col.key);
    columnsSchema: any = InaSchoolColumns;

    isSaving: boolean = false;
    viewAccess: boolean = false;
    editAccess: boolean = false;
    deleteAccess: boolean = false;
    showButtonUserRegion:boolean=true;

    userRegion: Region;
    studentRegion: Region;

    horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    verticalPosition: MatSnackBarVerticalPosition = 'top';

    dataSource = new MatTableDataSource<EditableInaSchoolEnrollment>();


    constructor(
        private router: Router,
        private helperService: HelperService,
        public accessService: AccessService,
        public inaSchoolEnrollmentsService: InaSchoolEnrollmentsService,
        /// private navigationObj: NavigationComponent
        private msgBar: MatSnackBar) { }

    ngOnInit(): void {
        
        this.accessService.allRegion().subscribe((res: Region[]) => {
            this.studentRegion = res.find((x) => x.ID == this.lstEditableINASE[0].inaSchoolEnrollment.RegionId)!;            
        });

        this.accessService.featureAccessible('View INA/ILP Form').subscribe((x) => 
        {
            this.viewAccess = x;
        }
        );
        this.accessService.featureAccessible('Edit INA/ILP').subscribe((x) => (this.editAccess = x));
        this.accessService.featureAccessible('Delete INA/ILP').subscribe((x) => (this.deleteAccess = x));

        this.accessService.adminUser().subscribe((adminUser:boolean)=>{
            if(!adminUser)
            {
                this.getUserRegion();        
                this.showButtonUserRegion= this.studentRegion.CODE==this.userRegion.CODE;
            }
        })
    }

    ngOnChanges(): void {
        this.dataSource.data = JSON.parse(JSON.stringify(this.lstEditableINASE));
        this.dataSource.paginator = this.paginator;
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    removeINASchoolEnrollment(row: EditableInaSchoolEnrollment) {
        if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) {
            row.isEdit = true;
            row.isDelete = true;
        }
    }
    deleteRow(row: EditableInaSchoolEnrollment) {
        this.isSaving = true;

        this.removeINASchoolEnrollment(row);
        
        this.inaSchoolEnrollmentsService.deleteINA({ InaId: row.inaSchoolEnrollment.Id }).subscribe((x) => {
            this.isSaving = false;
            let msg: boolean = x['inaSchoolEnrollment'];
            if (msg) {
                this.statusReset('Successfully deleted INA/ILP...');
                this.modificationEvent.emit(row);
            }
            else {
                this.statusReset('Unable to delete INA/ILP...')
            }
        });
    }
    cancelRow(row: EditableInaSchoolEnrollment) {
        row.isEdit = false;
        row.isDelete = false;
    }
    OpenNewTab(row: EditableInaSchoolEnrollment, action: string) {
        let routeURL: string = ''
        if (action == 'edit') {
            routeURL = '/children/' + row.inaSchoolEnrollment.StudentId + '/ina/' + row.inaSchoolEnrollment.Id + '/edit';
        }
        else if (action == 'view') {
            routeURL = '/children/' + row.inaSchoolEnrollment.StudentId + '/ina/' + row.inaSchoolEnrollment.Id + '/view';
        }        
       /* const url = this.router.serializeUrl(
            this.router.createUrlTree([routeURL])
        );*/

        console.log("now we will load url the new way with:")
        
        //console.log(url)
        console.log(routeURL)
  
   
        //window.open(url, '_blank');
        const absoluteURL = window.location.origin + routeURL;
         window.open(absoluteURL, '_blank');
       // this.router.navigate(routeURL2);


        //studentid:232923
        //inaId: 110512



    }

    getUserRegion() {
        this.helperService.lstUserProfileRegion$.subscribe((userRegion: Region[]) => {
            this.userRegion = userRegion[0];
        });
    }



    statusReset(msg: string) {
        this.msgBar.open(msg, '', {
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            duration: 3000
        });
    }
}

export const InaSchoolColumns = [
    { key: 'isEdit', type: 'boolean', label: '' },
    { key: 'schoolYear', type: 'date', label: 'School Year' },
    { key: 'district', type: 'text', label: 'District' },
    { key: 'school', type: 'date', label: 'School' },
    { key: 'type', type: 'text', label: 'Type' },
    { key: 'grade', type: 'boolean', label: 'Grade' },
    { key: 'inaStatus', type: 'boolean', label: 'INA/ILP Status' },
    { key: 'inaVersion', type: 'boolean', label: 'INA/ILP Version' },
    { key: 'createdDate', type: 'boolean', label: 'Created by / Date' },
    { key: 'followDate', type: 'boolean', label: 'Updated by / Date' },

];
